import React from 'react';

export function Skeleton({ width, height, className = '' }) {
  const style = {
    width,
    height,
  };
  return <div className={`skeleton ${className}`.trim()} style={style} />;
}
